// extracted by mini-css-extract-plugin
export default {"root":"Home_root__ELn0y","flex1":"Home_flex1__8-kPt","map":"Home_map__gzYb2","homeBtn":"Home_homeBtn__ydDUV","bannerContainer":"Home_bannerContainer__gi4wV"};